module.exports = __webpack_public_path__ + "static/media/si.ff87c652.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/si.svg
// module id = 1470
// module chunks = 0